module.exports = __webpack_public_path__ + "fonts/HSESans-SemiBold.4e10450.otf";